import * as yup from 'yup';

export const initialValues = {
  reason: '',
};

export const validationSchema = yup.object().shape({
  reason: yup.string().required('Reason is required'),
});
